import React from 'react';
import cn from 'classnames';
import './styles.scss';

const ViewTitle = (props) => {
  return (
    <h1 className={cn('view__title', props.className)}>
      {props.children}
    </h1>
  );
};

export default ViewTitle;
